import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-32d46106")

_pushScopeId("data-v-32d46106")
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_3 = { class: "text-red-lp-100" }
const _hoisted_4 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_5 = {
  class: 
        `select w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md px-4 z-50 overflow-x-show`
      ,
  style: {"max-height":"80vh"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: " text-red-lp-100 absolute top-0 right-0 mt-2 mr-2" }, "Reset", -1)
const _hoisted_7 = { class: "px-1 py-4 border-b border-gray-lp-400" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }, " Status Kargo ", -1)
const _hoisted_9 = { class: "px-1 py-4 border-b border-gray-lp-400" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }, " Transportasi ", -1)
const _hoisted_11 = { class: "px-1 py-4 border-b border-gray-lp-400" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }, " Klien ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: 
      `advanced-filter inline-block relative width-advance-filter bottom-0 left-0 text-12px xxl:text-14px mr-2 ${_ctx.openFilter &&
        'w-300px'}`
    
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.openFilter && !_ctx.isDisabled ? 'rounded-t' : 'rounded'
        } border text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      ,
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
          _ctx.$emit('opened', _ctx.openFilter);
        }
      )
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", {
          class: _ctx.isDisabled && 'opacity-50'
        }, [
          _hoisted_2,
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.sumFilter !== 0 ? `(${_ctx.sumFilter})` : ""), 1)
        ], 2)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              alt: "up"
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          ),
              alt: "down"
            }, null, 2))
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_5, [
      (_ctx.sumFilter > 0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
            class: "relative cursor-pointer w-full mb-4"
          }, [
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Select, {
          dataSelect: _ctx.statusData,
          onOpenSelect: _ctx.onOpenStatusSelect,
          onCloseSelect: _ctx.onCloseStatusSelect,
          onChooseSelect: _ctx.onSelectStatus,
          value: _ctx.filterData.status,
          isOpenMenu: _ctx.statusSelect,
          class: "whitespace-nowrap"
        }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_CustomDropdown, {
          selectedItem: _ctx.transportType,
          "onUpdate:selectedItem": _cache[4] || (_cache[4] = ($event: any) => (_ctx.transportType = $event)),
          options: _ctx.transportTypeData,
          placeholder: "Pilih Transportasi",
          onSelect: _cache[5] || (_cache[5] = (val) => _ctx.onChangePagination(1, val))
        }, null, 8, ["selectedItem", "options"])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_SelectSearch, {
          isLoading: _ctx.isLoadingClientPartner,
          options: _ctx.mappedDataClient,
          keyName: "display",
          keyValue: "id",
          placeholder: "Nama Klien Induk",
          modelValue: _ctx.clientValue,
          "onUpdate:modelValue": [
            _cache[6] || (_cache[6] = ($event: any) => (_ctx.clientValue = $event)),
            _ctx.onChangeClient
          ],
          "server-side": false
        }, null, 8, ["isLoading", "options", "modelValue", "onUpdate:modelValue"])
      ])
    ], 512), [
      [_vShow, _ctx.openFilter && !_ctx.isDisabled]
    ])
  ], 2)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.$emit('opened', true);
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.$emit('opened', false);
          _ctx.openFilter = false;
        }
      }
    ]
  ])
})